import styled from "styled-components";
import { Link } from "react-router-dom";

export const StyledFooterMainDiv = styled.div`
  display: flex;
  font-size: 30px;
  background: #8dabe2;
  color:#ffffff;
  padding: 10px 20px;
  box-sizing: border-box;
  @media (max-width: 600px) {
    font-size: 16px;
  }
`;


export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
`;

// Each footer item always keeps its own third of the row (never reflows
// into a stacked row) - min-width: 0 lets the item shrink below its text's
// natural width so the text wraps internally instead of overflowing.
export const StyledPrivacyLink = styled(Link)`
  flex: 1 1 0;
  min-width: 0;
  text-align: left;
  word-wrap: break-word;
`;

export const StyledTermsLink = styled(Link)`
  flex: 1 1 0;
  min-width: 0;
  text-align: center;
  word-wrap: break-word;
`;

export const StyledVersion = styled.div`
  flex: 1 1 0;
  min-width: 0;
  text-align: right;
  word-wrap: break-word;
`;
